import { useEffect, useState } from "react";
import { api } from "@/api";
import { Seo } from "@/components/Seo";
import { MaskedLine, Reveal } from "@/components/Motion";
import { EventCard } from "@/components/EventCard";

const filters = [
  { label: "All machines", value: "all" },
  { label: "Motorcycles", value: "motorcycles" },
  { label: "Cars", value: "cars" },
  { label: "Both", value: "both" },
];

export default function Events() {
  const [events, setEvents] = useState([]);
  const [category, setCategory] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/events", { params: { category } })
      .then((response) => setEvents(response.data))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div data-testid="events-page" className="min-h-screen bg-onyx pt-32">
      <Seo title="Events Library" description="Browse mellowjmedia motorcycle, car, and mixed automotive event albums." />
      <section className="mx-auto max-w-[1600px] px-4 sm:px-8 lg:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.42em] text-gold">Event library</p>
        <h1 className="mt-6 font-display text-5xl font-light leading-none text-white sm:text-7xl">
          <MaskedLine>Every gathering.</MaskedLine>
          <MaskedLine delay={0.14}><span className="italic text-titanium">Every frame.</span></MaskedLine>
        </h1>
        <div className="mt-12 flex flex-wrap gap-3" role="list" aria-label="Event category filters">
          {filters.map((filter) => (
            <button key={filter.value} data-testid={`album-filter-${filter.value}`} onClick={() => setCategory(filter.value)} className={`border px-5 py-3 font-mono text-[11px] uppercase tracking-[0.22em] transition-colors ${category === filter.value ? "border-gold bg-gold text-onyx" : "border-white/10 text-zinc-400 hover:border-gold/50 hover:text-white"}`}>
              {filter.label}
            </button>
          ))}
        </div>
      </section>
      <section className="mx-auto max-w-[1600px] px-4 py-16 sm:px-8 lg:px-12 lg:py-24">
        {loading && <p data-testid="events-loading-state" className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">Loading archive</p>}
        {!loading && events.length === 0 && <p data-testid="events-empty-state" className="border border-white/10 p-10 text-zinc-500">No events found in this category.</p>}
        <div className="grid gap-6 lg:grid-cols-12">
          {events.map((event, index) => (
            <Reveal key={event.id} className={index === 0 ? "lg:col-span-7" : index === 1 ? "lg:col-span-5" : "lg:col-span-4"}>
              <EventCard event={event} index={index} large={index === 0} />
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
